// Base UI
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faAlignLeft,
  faArrowLeft,
  faArrowUpFromBracket,
  faBars,
  faBold,
  faBolt,
  faBook,
  faBookmark,
  faBox,
  faBuilding,
  faCalculator,
  faCalendar,
  faCalendarAlt,
  faCamera,
  faCaretDown,
  faCaretUp,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faClock,
  faCog,
  faCogs,
  faCommentAlt,
  faCompress,
  faCompressArrowsAlt,
  faCopy,
  faCrosshairs,
  faDatabase,
  faDollarSign,
  faDotCircle,
  faDownload,
  faDrawPolygon,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faExternalLinkSquareAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileArrowDown,
  faFileCode,
  faFileDownload,
  faFileExport,
  faFilePdf,
  faFilter,
  faFingerprint,
  faFont,
  faHashtag,
  faHighlighter,
  faHistory,
  faHome,
  faIdCard,
  faIdCardClip,
  faImage,
  faImages,
  faItalic,
  faKeyboard,
  faLaptop,
  faLayerGroup,
  faLink,
  faList,
  faLock,
  faMarker,
  faMinus,
  faPaintRoller,
  faPen,
  faPersonCircleExclamation,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRandom,
  faRedo,
  faRepeat,
  faSave,
  faSearch,
  faSearchPlus,
  faShieldAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faStar,
  faTachometerAlt,
  faTags,
  faTextWidth,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTrash,
  faTrashAlt,
  faUnderline,
  faUnlink,
  faUser,
  faUserPlus,
  faUsers,
  faUserShield,
  faUserSlash,
  faUserTag,
  faUserTimes,
  faWeightHanging,
  faWindowRestore,
  faXRay,
} from '@fortawesome/free-solid-svg-icons';

import {
  faBookmark as faBookmarkRegular,
  faCheckSquare,
  faSquare,
} from '@fortawesome/free-regular-svg-icons';

import {
  faApostrophe,
  faText,
  faBrowser,
  faFiles,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faFile as faFileLight,
  faCheckCircle as faCheckCircleLight,
  faCircleXmark as faCircleXmarkLight,
} from '@fortawesome/pro-light-svg-icons';

export function faInit() {
  library.add(
    faAddressCard,
    faAlignLeft,
    faApostrophe,
    faArrowLeft,
    faArrowUpFromBracket,
    faBars,
    faBold,
    faBolt,
    faBook,
    faBookmark,
    faBox,
    faBookmarkRegular,
    faBrowser,
    faBuilding,
    faCalculator,
    faCalendar,
    faCalendarAlt,
    faCamera,
    faCaretDown,
    faCaretUp,
    faChartLine,
    faCheck,
    faCheckCircle,
    faCheckCircleLight,
    faCircleXmarkLight,
    faCheckSquare,
    faChevronDown,
    faChevronRight,
    faClock,
    faCog,
    faCogs,
    faCommentAlt,
    faCompress,
    faCompressArrowsAlt,
    faCopy,
    faCrosshairs,
    faDatabase,
    faDollarSign,
    faDotCircle,
    faDownload,
    faDrawPolygon,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEnvelopeOpen,
    faEnvelopeOpen,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye,
    faEyeSlash,
    faFile,
    faFileAlt,
    faFileArrowDown,
    faFileCode,
    faFileDownload,
    faFileExport,
    faFilePdf,
    faFiles,
    faFileLight,
    faFilter,
    faFilter,
    faFingerprint,
    faFont,
    faHashtag,
    faHighlighter,
    faHistory,
    faHome,
    faIdCard,
    faIdCardClip,
    faImage,
    faImages,
    faItalic,
    faKeyboard,
    faLaptop,
    faLayerGroup,
    faLink,
    faList,
    faLock,
    faMarker,
    faMinus,
    faPaintRoller,
    faPen,
    faPersonCircleExclamation,
    faPlus,
    faPlusCircle,
    faQuestionCircle,
    faRandom,
    faRedo,
    faRepeat,
    faSave,
    faSearch,
    faSearchPlus,
    faShieldAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faStar,
    faSquare,
    faTachometerAlt,
    faTags,
    faText,
    faTextWidth,
    faTimes,
    faTimesCircle,
    faToggleOff,
    faToggleOn,
    faTrash,
    faTrashAlt,
    faUnderline,
    faUnlink,
    faUser,
    faUserPlus,
    faUsers,
    faUserShield,
    faUserSlash,
    faUserTag,
    faUserTimes,
    faWeightHanging,
    faWindowRestore,
    faXRay,
  );
  // allow fontawesome-svg-core to convert i tags to svg icons
  dom.watch();
}
